import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Separator = styled.hr<{ $height?: number, $color?: COLORS, $hideLast?: boolean }>`
    height: ${({ $height = 1 }) => `${$height}px`};
    background-color: ${({ $color = COLORS.Control }) => $color};
    width: 100%;
    margin: 0;
    border-width: 0;

    ${({ $hideLast }) => $hideLast && css`
        &:last-child {
            display: none;
        }
    `}
`;
